import { DEFAULT_ERROR_MESSAGE } from "../../HistoriografijaConstants"

export default function translateErrorMessageFromBackend (errorMsg) {
    if (!errorMsg) return DEFAULT_ERROR_MESSAGE
    if(errorMsg.includes('Bad credentials'))
        return 'Netačni podaci.'
    if(errorMsg.includes('You are not authorized for this action'))
        return 'Niste autorizovani za ovu akciju.'
    if(errorMsg.includes('Please login'))
        return 'Potrebno je da se prijavite.'
    if(errorMsg.includes('Network error'))
        return 'Došlo je do greške. Pokušajte ponovo za nekoliko sekundi.'
    if(errorMsg.includes('Username is in invalid format'))
        return 'Netačni podaci.'
    if(errorMsg.includes('Password is in invalid format'))
        return 'Netačni podaci.'
    if(errorMsg.includes('Email address is in invalid format'))
        return 'Email adresa nije ispravna.'
    if(errorMsg.includes('email_unique_index already exists'))
        return 'Pokušajte se registrovati sa drugom email adresom.'
    if(errorMsg.includes('username_unique_index already exists'))
        return 'Korisničko ime već postoji. Odaberite neko drugo.'
    if(errorMsg.includes('Account is not verified.'))
        return 'Kliknite na link koji ste dobili na email da aktivirate svoj račun.'
    if(errorMsg.includes('User not found'))
        return 'Korisnik nije pronađen.'
    if(errorMsg.includes('url_unique_index'))
        return 'Url mora biti jedinstven.'
    if(errorMsg.includes('orcid_unique_index'))
        return 'Orcid autora mora biti jedinstven.'
    if(errorMsg.includes('image_name_unique_index'))
        return 'Naziv slike već postoji. Mora biti jedinstven.'
    if(errorMsg.includes('SQL error cause unkown'))
        return 'Greška u bazi.'
    if (errorMsg.includes('Contact technical support. Cannot edit image connected to multiple articles.'))
        return 'Slika je povezana s više članaka i ne može se urediti ovim putem. Kontaktirajte tehničku podršku.'
    if(errorMsg.includes('could not execute statement'))
        return DEFAULT_ERROR_MESSAGE
    if(errorMsg.includes('Password not correct'))
        return 'Trenutna lozinka koju ste unijeli nije tačna.'
    if(errorMsg.includes('User id is mandatory'))
        return 'Korisnik nije pronađen.'
    if(errorMsg.includes('Old password is mandatory'))
        return 'Obavezno je unijeti staru lozinku.'
    if(errorMsg.includes('New password is mandatory'))
        return 'Obavezno je unijeti novu lozinku.'
    if(errorMsg.includes('request is mandatory'))
        return 'Neispravni podaci.'
    
    return errorMsg
}